'use client';

var translations = {
    'Select your CV to analyse': 'Lựa chọn hồ sơ để đánh giá',
    'Checkout to see result': 'Thanh toán để xem kết quả',
    'View result': 'Xem kết quả',
    'Select an available profile on VietnamWorks.': 'Chọn hồ sơ có sẵn trên VietnamWorks',
    '/cv-review': '/phan-tich-ho-so',
    'Sorry, we cannot process your CV. Please select another CV.': 'Rất tiếc, chúng tôi không thể xử lý CV của bạn. Vui lòng chọn CV khác.',
    'Please upload your CV to see the evaluation.': 'Vui lòng tải hồ sơ của bạn để xem đánh giá.',
    'Uploaded attachment will be added to your VietnamWorks account': 'Hồ sơ tải lên sẽ được thêm vào tài khoản VietnamWorks của bạn',
    "Scanning file's content": 'Đang quét nội dung hồ sơ',
    'Evaluated for the position of': 'Đánh giá cho vị trí',
    Price: 'Giá',
    'You have {0} free trial': 'Bạn có {0} lần dùng thử miễn phí',
    time: 'lượt',
    'Maximize your competitive advantage with VietnamWorks AI': 'Tối ưu lợi thế cạnh tranh cùng VietnamWorks AI',
    "Assess matching rate from employer's viewpoint": 'Đánh giá độ phù hợp với góc nhìn của nhà tuyển dụng',
    'Suggest to improve the matching': 'Gợi ý cách cải thiện mức độ phù hợp',
    'Analyze the profiles of applicants': 'Phân tích hồ sơ của các ứng viên đã nộp đơn',
    'Check salary reference and hiring demand': 'Tham khảo mức lương và nhu cầu tuyển dụng'
};

export { translations };
//# sourceMappingURL=translations.js.map
